import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";
import { StatementsFilter } from "./components/TableStatements/filters/types";

export const PATH_STATEMENTS = "/member/statements";

/**
 * Route helpers for the Statements page. The page has no route params — its
 * state lives entirely in the URL `search` (the account-type filter), so
 * consumers can deep-link to a pre-filtered table:
 *
 * routeHelpersStatements.createLocationObject({
 *   search: { filter: { accountType: InternalAccountType.BANKING } }
 * });
 *
 * The shape mirrors what `useUrlQuery` reads back inside the table.
 */
export const routeHelpersStatements = createRouteHelpers<
  never,
  { search: { filter?: StatementsFilter } }
>(PATH_STATEMENTS);
